import merge from 'lodash/merge';
import cloneDeep from 'lodash/cloneDeep';
import {
  designTokens,
  designTokensMobile,
  designTokensKiosk,
  designTokensLargeScreenKiosk,
} from '@vmos2/design-system';
import {
  componentsTheme,
  componentsThemeMobile,
  componentsThemeKiosk,
  componentsThemeLargeScreenKiosk,
} from './components.theme';

export const defaultTheme = {
  default: {
    ...designTokens,
    components: componentsTheme(designTokens),
    storeSelection: {
      primaryBgColor: '',
      backgroundImage: '',
    },
    cart: {
      primaryBgColor: '',
      backgroundImage: '',
      largeBackgroundImage: '',
    },
    payment: {
      primaryBgColor: '',
      kioskBackgroundImage: 'https://s3.vitamojo.com/static/kiosk-payment.png',
      largeKioskBackgroundImage: '',
      backgroundImage: 'https://s3.vitamojo.com/static/vitamojo.jpg',
      kioskTableNumberImage: '',
    },
    menu: {
      primaryBgColor: '',
      backgroundImage: '',
    },
    category: {
      primaryBgColor: '',
      backgroundImage: '',
    },
    orderConfirmation: {
      primaryBgColor: '',
      kioskBackgroundImage: '',
      largeKioskBackgroundImage: '',
      backgroundImage: '',
      brandImage: '',
    },
    brandImage: {
      backgroundImage: '',
      textColor: '',
      alignItems: 'flex-start',
      textAlign: 'left',
      link: '',
    },
    emailReceipt: {
      backgroundImage: 'https://s3.vitamojo.com/static/kiosk-confirmation-bg.jpg',
    },
    orderHistory: {
      primaryBgColor: '',
      backgroundImage: '',
      kioskBackgroundImage: '',
      largeBackgroundImage: '',
      largeKioskBackgroundImage: '',
    },
    mySettings: {
      primaryBgColor: '',
      backgroundImage: '',
      kioskBackgroundImage: '',
      largeBackgroundImage: '',
      largeKioskBackgroundImage: '',
      visible: true,
    },
    marketingPreference: {
      backgroundImage: '',
      visible: true,
    },
    accountRewards: {
      backgroundImage: '',
      kioskBackgroundImage: '',
      largeBackgroundImage: '',
      largeKioskBackgroundImage: '',
      primaryBgColor: '',
      componentsOrder: [],
    },
    auth: {
      primaryBgColor: '',
      backgroundImage: '',
    },
    splashScreen: {
      fallbackBackground: '',
    },
    landingPage: {
      primaryBgColor: '',
      backgroundImage: '',
      nameColor: '',
      descriptionColor: '',
      alignItems: 'flex-start',
      textAlign: 'left',
    },
    diningType: {
      primaryBgColor: '',
      backgroundImage: '',
    },
    paymentModal: {
      paymentMethodBackground: 'https://staging.vmos-static.com/1580462038421_paymentMethod.svg',
    },
    externalPayAtCounterModal: {
      cardPaymentMethod: 'https://s3.vitamojo.com/static/card-payment-method.svg'
    },
    externalPayAtCounterFailedModal: {
      paymentFailedColor: '#CF0000',
    },
    mealDeal: {
      backgroundImage: '',
    },
    loyalty: {
      rewardsPoints: {
        logo: '',
      },
    },
    paymentCards: {
      amex: 'https://s3.vitamojo.com/static/americanexpress.0ebecc3f+1.svg',
      maestro: 'https://s3.vitamojo.com/static/maestro.e4268490.svg',
      mastercard: 'https://s3.vitamojo.com/static/mastercard.05d422d1.svg',
      visa: 'https://s3.vitamojo.com/static/visa.147ed198.svg',
      apple: 'https://s3.vitamojo.com/static/apple.svg',
      google: 'https://s3.vitamojo.com/static/google.svg',
      applePay: 'https://s3.vitamojo.com/static/apple-button.svg',
      googlePay: 'https://s3.vitamojo.com/static/google-button.svg',
      paypal: 'https://s3.vitamojo.com/static/paypal.svg',
    },
    tierSystem: {
      progressBarColour: '',
      tiers: [
        {
          level: 1,
          icon: 'Star',
          bgColour: '',
          customIcon: '',
        },
        {
          level: 2,
          icon: 'Medal',
          bgColour: '',
          customIcon: '',
        },
        {
          level: 3,
          icon: 'Trophy',
          bgColour: '',
          customIcon: '',
        },
        {
          level: 4,
          icon: 'Crown',
          bgColour: '',
          customIcon: '',
        },
      ],
    },
    introduction: {
      backgroundImage: '',
      largeBackgroundImage: '',
      logo: '',
      primaryBgColor: '',
    },
    kioskConfig: {
      backgroundImage: '',
      kioskBackgroundImage: '',
      largeBackgroundImage: '',
      largeKioskBackgroundImage: '',
      primaryBgColor: '',
    },
    onboarding: {
      step1: {
        backgroundImage: '',
        largeBackgroundImage: '',
        primaryBgColor: '',
      },
      step2: {
        backgroundImage: '',
        largeBackgroundImage: '',
        primaryBgColor: '',
      },
      step3: {
        backgroundImage: '',
        largeBackgroundImage: '',
        primaryBgColor: '',
      },
    },
    pointsShop: {
      backgroundImage: '',
      largeBackgroundImage: '',
      largeKioskBackgroundImage: '',
      primaryBgColor: '',
    },
    subscriptions: {
      backgroundImage: '',
      kioskBackgroundImage: '',
      largeBackgroundImage: '',
      largeKioskBackgroundImage: '',
      primaryBgColor: '',
    },
    welcome: {
      backgroundImage: '',
      hideOrderNowContent: false,
      largeBackgroundImage: '',
      primaryBgColor: '',
      componentsOrder: [],
    },
    bundleCustomization: {
      primaryBgColor: 'white',
    },
  },
  kiosk: {
    ...designTokensKiosk,
    components: componentsThemeKiosk(merge(cloneDeep(designTokens), designTokensKiosk)),
  },
  largeScreenKiosk: {
    ...designTokensLargeScreenKiosk,
    components: componentsThemeLargeScreenKiosk(merge(cloneDeep(designTokens), designTokensLargeScreenKiosk)),
  },
  mobile: {
    ...designTokensMobile,
    components: componentsThemeMobile(merge(cloneDeep(designTokens), designTokensMobile)),
  },
};
